function readAccessTokenFromRecord(o: Record<string, unknown>): string | null {
  const direct = o.accessToken ?? o.access_token ?? o.token ?? o.AccessToken;
  if (typeof direct === 'string' && direct.trim()) {
    return direct.trim();
  }
  return null;
}

/** Login JSON may nest tokens under `data`, `auth`, `tokens`, etc. (same field names as refresh). */
export function extractAccessTokenFromLoginJson(parsed: unknown): string | null {
  if (!parsed || typeof parsed !== 'object' || parsed === null) {
    return null;
  }
  const o = parsed as Record<string, unknown>;
  const top = readAccessTokenFromRecord(o);
  if (top) {
    return top;
  }
  for (const key of ['data', 'result', 'auth', 'tokens', 'payload']) {
    const nested = o[key];
    if (nested && typeof nested === 'object' && nested !== null && !Array.isArray(nested)) {
      const token = readAccessTokenFromRecord(nested as Record<string, unknown>);
      if (token) {
        return token;
      }
    }
  }
  return null;
}
